import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {fetchPublishedAnswersList} from './search';
import {kc} from '../../common/service/keycloak';

export const fetchVehiclesBatch = (chassisList) => () => {
  const baseUrl = process.env.REP_API_URL; // microservicio 'part', igual que el middleware
  return fetch(`${baseUrl}/vehicles/chassis-batch`, {
    'method': 'POST',
    'headers': {
      'Authorization': `Bearer ${kc.token}`,
      'Content-Type': 'application/json',
    },
    'body': JSON.stringify({'chassisList': chassisList}),
  })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    })
    .then((json) => (json && json.data ? json.data : []))
    .catch(() => []);
};

export const fetchOnlyAnswers = (answerId) => apiActionCreator({
  'endpoint': `/answers/${answerId}/responses`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ONLY_FORM_ANSWERS,
    ActionTypes.FETCHED_ONLY_FORM_ANSWERS,
    [
      ActionTypes.FETCHED_ONLY_FORM_ANSWERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'GET',
});

export const fetchFormTemplate = (formId, answerId) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/forms/${formId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_FORM_TEMPLATE,
        [
          () => {
            if (answerId) {
              dispatch(fetchOnlyAnswers(answerId));
            }
            return {
              'type': ActionTypes.FETCHED_FORM_TEMPLATE,
            };
          },
        ],
        [
          ActionTypes.FETCHED_FORM_TEMPLATE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'form',
      'method': 'GET',
    }),
  );
};

export const showMessage = (autosaved) => {
  if (autosaved) {
    return {
      'type': ActionTypes.DO_NOT_SHOW_MESSAGE,
    };
  }
  return MessageActions.addMessageBoxInfo('Formulario guardado satisfactoriamente');
};

export const saveForm = (data, autosave) => apiActionCreator({
  'endpoint': '/answers',
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_FORM,
    [
      {
        'type': ActionTypes.SAVED_FORM,
        'payload': autosave,
      },
      () => showMessage(autosave),
    ],
    [
      ActionTypes.SAVED_FORM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'POST',
  data,
});

export const fetchChassisInfo = (chassis, skr = 'N') => apiActionCreator({
  'endpoint': `/vehicles/chassis/${chassis}?skr=${skr}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_CHASSIS_INFO,
    ActionTypes.FETCHED_CHASSIS_INFO,
    [
      ActionTypes.FETCHED_CHASSIS_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchFormResponse = (answerId, type, skr = 'N') => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/answers/${answerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_FORM_RESPONSE,
        [
          (response) => {
            console.log('=== generalInfo ===', JSON.stringify(response.data.generalInfo));
            console.log('=== answers ===', JSON.stringify(response.data.answers));
            console.log('=== raiz keys ===', Object.keys(response.data));

            if (response.data.generalInfo && response.data.generalInfo.chassis) {
              dispatch(fetchChassisInfo(response.data.generalInfo.chassis, skr));
            }
            return {
              'type': ActionTypes.FETCHED_FORM_RESPONSE,
              'payload': type,
            };
          },
        ],
        [
          ActionTypes.FETCHED_FORM_RESPONSE_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'microservice': 'form',
      'method': 'GET',
    }),
  );
};

export const updateForm = (answerId, data, autosave) => apiActionCreator({
  'endpoint': `/answers/${answerId}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_FORM,
    [
      {
        'type': ActionTypes.SAVED_FORM,
        'payload': autosave,
      },
      () => showMessage(autosave),
    ],
    [
      ActionTypes.SAVED_FORM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'PUT',
  data,
});

export const deleteFtr = (answerId) => apiActionCreator({
  'endpoint': `/answers/${answerId}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_FORM,
    [
      ActionTypes.DELETED_FORM,
      MessageActions.addMessageBoxInfo('Formulario eliminado satisfactoriamente'),
    ],
    [
      ActionTypes.DELETED_FORM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'form',
  'method': 'DELETE',
});

export const updateStateServiceForm = (answerId, data, filters) => (dispatch) => {
  return dispatch(apiActionCreator({
    'endpoint': `/answers/${answerId}/form`,
    'authenticated': true,
    'types': [
      ActionTypes.UPDATING_STATE_FORM,
      [
        () => {
          dispatch(fetchPublishedAnswersList(filters));
          return {
            'type': ActionTypes.UPDATED_STATE_FORM,
          };
        },
        (response) => MessageActions.addMessageBoxInfo('Registro Actualizado'),
      ],
      [
        ActionTypes.UPDATED_STATE_FORM_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'form',
    'contentType': 'application/json',
    'method': 'PUT',
    'data': data,
  }));
};

export const clearPublishedAnswersList = () => ({
  'type': ActionTypes.CLEAR_PUBLISHED_ANSWERS_LIST,
});

export const clearForm = () => ({
  'type': ActionTypes.CLEAR_FORM,
});

export const changeSavedValue = (value) => ({
  'type': ActionTypes.CHANGE_SAVED_VALUE,
  'payload': value,
});

export const setValueInForm = ({fieldType, fieldId, optionId, value, isOther, isMultipleSelection}) => ({
  'type': ActionTypes.SET_VALUE_IN_FORM,
  'payload': {fieldType, fieldId, optionId, value, isOther, isMultipleSelection},
});

export const setAttachments = (files) => ({
  'type': ActionTypes.SET_FILES,
  'payload': files,
});

export const setGeneralInfo = (field, value) => ({
  'type': ActionTypes.SET_GENERAL_INFO,
  'payload': {field, value},
});
